import React from 'react';
import { MessageCircle, Youtube, Send } from 'lucide-react';
import './Contacts.css';

const Contacts = () => {
  return (
    <section className="contacts-page">
      <div className="contacts-page__layout">
        <iframe
          title="Карта с расположением студии"
          className="contacts-page__map"
          src="https://yandex.ru/map-widget/v1/?text=%D0%9C%D0%BE%D1%81%D0%BA%D0%B2%D0%B0%2C%20%D0%9D%D0%BE%D0%B2%D0%BE%D0%BC%D0%BE%D1%81%D0%BA%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F%20%D1%83%D0%BB%D0%B8%D1%86%D0%B0%2C%201&z=16"
          loading="lazy"
        />

        <aside className="contacts-page__panel">
          <div className="contacts-page__panel-head">
            <h1 className="contacts-page__title">Контакты</h1>
            <div className="contacts-page__socials">
              <a href="/#" aria-label="WhatsApp" className="contacts-page__social-link">
                <MessageCircle size={18} />
              </a>
              <a href="/#" aria-label="YouTube" className="contacts-page__social-link">
                <Youtube size={18} />
              </a>
              <a href="https://t.me/" aria-label="Telegram" className="contacts-page__social-link">
                <Send size={18} />
              </a>
            </div>
          </div>

          <div className="contacts-page__phones">
            <a href="tel:+79100002330" className="contacts-page__phone">
              +7 (910) 000-23-30
            </a>
          </div>

          <div className="contacts-page__text-group">
            <p className="contacts-page__label">Адрес</p>
            <p className="contacts-page__text">Москва, Новомосковская улица, 1</p>
          </div>

          <div className="contacts-page__text-group">
            <p className="contacts-page__label">Принимаем и консультируем:</p>
            <p className="contacts-page__text">11:00 - 20:00</p>
          </div>
        </aside>
      </div>
    </section>
  );
};

export default Contacts;
